import '../styles/Legal.scss';
import DoublePage from '../Components/DoublePage.js';

const Legal = () =>
    <DoublePage
        id="legal"
        minor={
            <div>
                <h1>Les Publinautes</h1>
                <p>SAS au capital de 98 800 Euros</p>
                <p>RCS Paris 332 965 060</p>
                <p>SIRET 332 965 060 00061</p>
                <p>TVA FR 56 332 965 060</p>
                <p>APE 7311Z</p>
                <h2>Contact</h2>
                <p>27 rue Daru - 75008 Paris</p>
                <p>Tél. conception : 01 53 94 55 94</p>
                <p>Tél. réalisation : 01 53 94 54 54</p>
                <p>email : <a href="mailto:h.gourdet@publinautes.com">h.gourdet@publinautes.com</a></p>
                <p id="cgdv-link"><a href="./CGDV.pdf" download="CGVD Les Publinautes.pdf"><img src="./pdf.png" alt="PDF" title="télécharger en PDF"/> <span class="underline">Conditions générales de vente</span></a></p>
            </div>
        }
        poster="./legal.jpg"
    />

export default Legal;